// Deterministic capacity extraction for Smart Asset Import.
//
// Client files often bury the rating inside a free-text model string,
// e.g. "ISP-IV 400 KVA", "200KVA", "4905GM 62.5 KVA". We extract the numeric value
// and unit for use in dedup keys and review display. The RAW string is always preserved;
// we never overwrite the source value with the parsed one.

const UNIT_PATTERNS = [
  { unit: 'KVA', re: /(\d+(?:\.\d+)?)\s*kva\b/i },
  { unit: 'KW', re: /(\d+(?:\.\d+)?)\s*kw\b/i },
  { unit: 'HP', re: /(\d+(?:\.\d+)?)\s*hp\b/i },
  { unit: 'TON', re: /(\d+(?:\.\d+)?)\s*(?:ton|tonne|mt)\b/i },
  { unit: 'L', re: /(\d+(?:\.\d+)?)\s*(?:ltr|litre|liter|l)\b/i },
];

/**
 * @returns {{ value:number|null, unit:string|null, status:'OK'|'NONE', raw:* }}
 */
export const parseCapacity = (text) => {
  if (text === null || text === undefined || String(text).trim() === '') {
    return { value: null, unit: null, status: 'NONE', raw: text };
  }
  const s = String(text);
  for (const { unit, re } of UNIT_PATTERNS) {
    const m = s.match(re);
    if (m) {
      const value = parseFloat(m[1]);
      if (Number.isFinite(value)) return { value, unit, status: 'OK', raw: text };
    }
  }
  return { value: null, unit: null, status: 'NONE', raw: text };
};
